import { api } from '../../shared/api/http'

export type LivePreference = { source: 'preview' | 'whep' | 'compatibility'; codec: string }
const capability = () => (RTCRtpReceiver.getCapabilities('video')?.codecs ?? [])
  .some(codec => codec.mimeType.toLowerCase() === 'video/h265') ? 'hevc' : 'h264'
function endpoint(key: string) {
  const parts = key.split('/')
  const camera = parts.pop(), company = parts.pop()
  const uuid = /^[0-9a-f-]{36}$/i
  return camera && company && uuid.test(camera) && uuid.test(company)
    ? `/companies/${company}/cameras/${camera}/playback-preference` : undefined
}
export async function preferredLiveSource(key: string, signal?: AbortSignal): Promise<LivePreference | undefined> {
  const path = endpoint(key)
  if (!path) return undefined
  try {
    const result = await api<{ preference: LivePreference | null }>(`${path}?platform=web&capability=${capability()}`, { signal })
    return result.preference ?? undefined
  } catch { return undefined }
}
export async function rememberLiveSource(key: string, source: LivePreference['source'], codec: string) {
  const path = endpoint(key)
  if (!path) return
  await api(path, { method: 'PUT', body: JSON.stringify({ platform: 'web', capability: capability(), source, codec }) })
}
